<template>
    <div class="flex items-center relative"  @mouseover="hover = true" @mouseout="hover = false">
      <div class="parent relative status-circle">
        <span :class="data.status" class="label rounded-full inline-block text-sm font-bold" style="padding: .4rem .7rem;">
            {{  computedStatus  }}
        </span>
        <div class="absolute group-hover:visible bg-black text-white px-4 mb-3 py-2 text-sm rounded-md transition-opacity shadow-sm click-events-none"
        v-if="hover" 
            style="top:-10px; left:calc(100% + 10px); z-index: 100; white-space: nowrap;"
        >
          <p class="leading-4 text-white">  {{ popupDescription }}</p>
          <svg class="absolute z-10 left-0 top-3.5" style="left: -13px; transform: rotate(90deg);" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 10L0 0L16 1.41326e-06L8 10Z" fill="#3a3a3a" class="bg-black"/>
          </svg>
        </div>
      </div>
    </div>

</template>

<script>

export default {
    name: "MessageTableStatus",
    props: {
        meta: {
            type: Object,
            default: () => {}
        },
        name: {
            type: String,
            default: ""
        },
        data: {
            type: Object,
            default: () => {}
        },
    },
    components: { },
    data: () => ({
        hover: false
    }),
    computed: {
        popupDescription() {
            if (this.data.status == "sent") {
                return "Message was sent and received by the receiving phone carrier."
            }
            if (this.data.status == "delivered") {
                return "Delivery was confirmed by the receiving carrier.";
            }
            if (this.data.status == "pending") {
                return "Your message is queued for sending.";
            }
            return this.data.error_message ? this.data.error_message : this.data.status;
        },
        computedStatus() {

            if (this.data.status == "attempt_rejected") {
                return "Failed";
            }

            return this.data.status;
        }
    },
    mounted() {

    },
    methods: {},
};
</script>

<style scoped lang="scss">

.status-circle {
    line-height: 12px;
}
span.label {
    text-transform: capitalize;
    cursor:help;
    &.delivered {
        @apply bg-green-300;
        @apply text-green-800;
    }
    &.sent {
        @apply bg-blue-300;
        @apply text-blue-800;
    }
    &.pending {
        @apply bg-yellow-300;
        @apply text-yellow-800;
    }
    &.undelivered {
        @apply bg-red-300;
        @apply text-red-800;
    }
    &.error, &.failed, &.attempt_rejected{
        @apply bg-gray-300;
        @apply text-gray-800;
    }
}
</style>
